var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.5C15.5 1.675 14.825 1 14 1H2C1.175 1 0.5 1.675 0.5 2.5M15.5 2.5V11.5C15.5 12.325 14.825 13 14 13H2C1.175 13 0.5 12.325 0.5 11.5V2.5M15.5 2.5L8 7.75L0.5 2.5",
    stroke: "#090E2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.1cdac0eccd8b94042ae9cf83a3150e06.svg";